import http from '../../plugins/axios';

export default {

    /**
     * 分页查询策略订阅配置
     * @param data
     * @returns {*}
     */
    getInfoPage(data) {
        return http.get({
            url: '/admin/strategy/info',
            data
        })
    },

    /**
     * 修改策略订阅配置
     * @param data
     * @returns {*}
     */
    updateInfoConf(data) {
        return http.post({
            url: '/admin/strategy/update',
            data,
            dataType: 'form'
        })
    },


    /**
     * 分页查询信号历史
     * @param data
     * @returns {*}
     */
    getSignalPage(data) {
        return http.get({
            url: '/admin/strategy/signal/list',
            data
        })
    },

    /**
     * 获取可用交易对
     * @param data
     * @returns {*}
     */
    getAllSupportingPairs(data) {
        return http.get({
            url: '/admin/coin/allDisplayPair',
            data
        })
    },

    /**
     * 分页查询订阅记录
     * @param data
     * @returns {*}
     */
    getSubRecordPage(data) {
        return http.get({
            url: '/admin/strategy/querySubRecordPage',
            data
        })
    },

    /**
     * 后管查询订阅历史
     * @param data
     * @returns {*}
     */
    getSubHistory(data) {
        return http.get({
            url: '/admin/strategy/adminSubHistoryPage',
            data
        })
    },
}
